import { render, staticRenderFns } from "./grade-level-card.vue?vue&type=template&id=b983c0f8&scoped=true&"
import script from "./grade-level-card.ts?vue&type=script&lang=ts&"
export * from "./grade-level-card.ts?vue&type=script&lang=ts&"
import style0 from "./grade-level-card.scss?vue&type=style&index=0&id=b983c0f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b983c0f8",
  null
  
)

export default component.exports